// Copyright 2024 - MinIO, Inc. All rights reserved.

import { Api, ApiError, FullRequestParams, HttpResponse } from "./consoleApi";
import { findUrlParts } from "./api.utils";

export let rootCnsApi = new Api();
// api.baseUrl = `/api/cns/${api.baseUrl}`;
const internalRequestFunc = rootCnsApi.request;
rootCnsApi.request = async <T = any, E = any>({
  body,
  secure,
  path,
  type,
  query,
  format,
  baseUrl,
  cancelToken,
  ...params
}: FullRequestParams): Promise<HttpResponse<T, E>> => {
  const urlParts = findUrlParts(window.location.href.split("/"), [
    "sites",
    "console",
  ]);

  const siteId = urlParts[0];
  const resourceID = urlParts[1];

  baseUrl = `/api/route/${siteId}/tenant/${resourceID}${rootCnsApi.baseUrl}`;
  const internalResp = internalRequestFunc({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params,
  });
  return internalResp.then(CommonAPIValidation);
};

export function CommonAPIValidation<D, E>(
  res: HttpResponse<D, E>,
): HttpResponse<D, E> {
  const err = res.error as ApiError;
  if (err && res.status === 403 && err.message === "invalid session") {
    document.location = "/";
  }
  return res;
}
